
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 69.97 69.26","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('path',{attrs:{"id":"Layer_2-2","d":"M69.26 38.33l-2.34 4.33a37.18 37.18 0 00-3.61 8.64L61.87 56a10.25 10.25 0 01-5.29 5.24l-4.75 1.43a37.14 37.14 0 00-8.73 3.58l-4.38 2.31a10.34 10.34 0 01-7.48 0l-4.37-2.31a37.14 37.14 0 00-8.73-3.58l-4.75-1.43A10.18 10.18 0 018.1 56l-1.44-4.7A36.79 36.79 0 003 42.66L.71 38.33a10 10 0 010-7.4L3 26.59A36.79 36.79 0 006.66 18l1.44-4.7A10.16 10.16 0 0113.39 8l4.75-1.43A37.75 37.75 0 0026.86 3L31.24.7A9.28 9.28 0 0135 0a9.28 9.28 0 013.74.7L43.1 3a38 38 0 008.73 3.58L56.58 8a10.23 10.23 0 015.29 5.23L63.31 18a37.18 37.18 0 003.61 8.64l2.34 4.34a10.06 10.06 0 010 7.4","data-name":"Layer 2"}}),_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-2",attrs:{"d":"M45.63 43.82H23.7V21.9h22.47v-1.08h-23a.54.54 0 00-.54.54v4.36h-4.37a.54.54 0 00-.54.54v23a.54.54 0 00.54.53h23a.54.54 0 00.54-.53V44.9h4.37a.54.54 0 00.54-.54V30.69h-1.08zm-4.91 4.91H18.8V26.8h3.82v17.56a.54.54 0 00.54.54h17.56z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M30.68 32.87l-.76.76L34 37.71a.54.54 0 00.38.15.56.56 0 00.39-.15l17.32-17.34-.76-.76-17 17z"}})])])])
          )
        }
      }
    